import { IProject } from "@/interfaces/project.interface"
import { ReactNode, useEffect, useMemo, useState } from "react"
import { useGetProjects } from "@/services/queries/useProject"
import { persistId, readPersistedId, resolveInitialProject } from "./projeto-helpers"
import { ProjectContext } from "./projeto-context"

export function ProjectProvider({ children }: { children: ReactNode }) {
  const [selectedProject, setSelectedProject] = useState<IProject | null>(null)
  const [isLogado, setIsLogado] = useState(false)

  const interval = setInterval(() => {
    if (!isLoading) {
      setIsLogado(localStorage.getItem("auth_token") !== null)
    }
  }, 1000)

  interval.close

  const { data: projectsData, isLoading, isError } = useGetProjects({
    enabled: isLogado,
  })

  const projects = useMemo<IProject[]>(() => {
    if (!Array.isArray(projectsData)) return []
    return projectsData
  }, [projectsData])

  useEffect(() => {
    if (!projects.length) return

    const persistedId = readPersistedId()
    const resolved = resolveInitialProject(projects, persistedId)

    setSelectedProject(resolved)
  }, [projects])

  const selecionarProjeto = (project: IProject | null) => {
    setSelectedProject(project)
    persistId(project ? String(project.id) : null)
  }

  return (
    <ProjectContext.Provider
      value={{
        projetoSelecionado: selectedProject,
        selecionarProjeto,
        projetos: projects,
        isLoading,
        isError,
      }}
    >
      {children}
    </ProjectContext.Provider>
  )
}